import { apiBaseURL } from "../ProjectConstants";

async function handlePutWorkPlan({
  fetch,
  formData,
  id,
  billingCode,
  headId = "",
}) {
  const startDate = formData.startDate?.toLocaleString("en-CA"),
    endDate = formData.endDate?.toLocaleString("en-CA");

  const body = {
    taskName: formData.taskName,
    allocatedEngHours: formData.allocatedEngHours,
    allocatedLabHours: formData.allocatedEngHours,
    completedPercentage: formData.completedPercentage,
    startDate: startDate.slice(0, 10),
    endDate: endDate.slice(0, 10),
    supervisorIds: formData.supervisorIds,
    billingCode: billingCode,
    description: "",
    remarks: formData.remarks,
    description: formData.description ?? "",
    exitCriteria: formData.exitCriteria ?? "",

    headId: headId,
    id: id,
  };

  const response = await fetch.put(`${apiBaseURL}/api/projectwo`, body);
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";

  console.log("usePutWorkPlan body", body);
  console.log("usePutWorkPlan response", response);

  return {
    response,
    isDataGood,
  };
}

export default handlePutWorkPlan;
